<form #filterTagForm="ngForm" class="mt-3">
    <div class="row pb-30">
      <div class="col-md-12 col-lg-12">
        <div class="row">
          <div class="col-md-2">
            <input type="text" class="form-control" required name="location" ngModel #location="ngModel"
              [(ngModel)]="dataForFilter.location"
              [typeahead]="locationList"
              [typeaheadOptionField]="'locationName'"
              (focusout)="safeLocation"
              (typeaheadOnSelect)="EnabledFilter($event)"
              placeholder="Select Location"
              autocomplete="off">
            <span class="text-danger" *ngIf="((location.invalid && location.touched) || filterErrMsg)">
              Location is required
            </span>
          </div>
        
          <div class="col-md-2">
            <ng-container *ngIf="disabledFlag === false">
              <input type="text" class="form-control" name="useCase" ngModel #useCase="ngModel"
                     [(ngModel)]="dataForFilter.useCase"
                     [typeahead]="useCaseList"
                     [typeaheadOptionField]="'useCaseName'"
                     (typeaheadOnSelect)="validateUseCase($event)"
                     (focusout)="checkUseCase(useCase)"
                     placeholder="Select Use Case"
                     autocomplete="off">
            </ng-container>
            <ng-container *ngIf="disabledFlag === true">
              <input type="text" class="form-control" name="useCase" ngModel #useCase="ngModel"
                     [(ngModel)]="dataForFilter.useCase"
                     [typeahead]="useCaseList"
                     [typeaheadOptionField]="'Use Case'"
                     placeholder="Select Use Case"
                     disabled="disabled">
            </ng-container>
          </div>
          <div class="col-md-2">
            <ng-container *ngIf="disabledFlag === false">
              <input type="text" class="form-control" name="tagId" ngModel #tagId="ngModel"
                     [(ngModel)]="dataForFilter.tagId"
                     [typeahead]="tags"
                     [typeaheadOptionField]="'tagId'"
                     (focusout)="tagIdFocusOut(tagId)"
                     placeholder="Select Tag Id"
                     autocomplete="off">
            </ng-container>
            <ng-container *ngIf="disabledFlag === true">
              <input type="text" class="form-control" name="tagId" ngModel #tagId="ngModel"
                     [(ngModel)]="dataForFilter.tagId"
                     [typeahead]="tags"
                     [typeaheadOptionField]="'tagId'"
                     placeholder="Select Tag Id"
                     autocomplete="off"
                     disabled>
            </ng-container>
          </div>
          <div class="col-md-2 col-lg-2">
            <button title="Filter Tags" class="btn searchBtn mr-3 mt-1" [disabled]="((!filterTagForm.valid) || filterErrMsg)" (click)="filterTags(filterTagForm);">
              Search
            </button>
          
            <button title="Clear Filter" class="btn clearBtn mr-3 mt-1" (click)="resetFilter()"> CLEAR </button>
            <button title={{globalService.tagMovMsg}} *ngIf="globalService.hasTagAdminAccess() && globals.subscription !== 'PROD'" [disabled]="!(tagIdsToExport.length > 0)" class="btn moveBtn mr-3 mt-1" (click)="moveTagAcrossPlatform()">{{globalService.tagMovMsg}}</button>            
          </div>
        </div>
      </div>
    </div>
</form>

<div class="d-flex flex-column tagTable">
  <mat-table #tagsTable #tagsTableSort="matSort" [dataSource]="tagList" matSort matSortDirection="asc" matSortDisableClear>
    <ng-container matColumnDef="export">
      <mat-header-cell *matHeaderCellDef class="TitleMatAction">
       Select
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="TitleMatAction">
        <mat-checkbox value="row.tagId" (change)="chkTagIds(row.id)" #checkbox name="tagIds" required
                      [checked]="isChecked(row.id)"></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="tagId">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="TitleMatEventID">Tag ID</mat-header-cell>
      <mat-cell *matCellDef="let row" class="TitleMatEventID">{{row.tagId}}</mat-cell>
    </ng-container>
    
    <ng-container matColumnDef="locationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
      <mat-cell *matCellDef="let row" class="TitleMatUom"> {{row.locationName}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="tenantName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Use case</mat-header-cell>
      <mat-cell *matCellDef="let row" class="TitleMatUom"> {{row.tenantName}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="tagDesc">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="ClsMatDescription">Description</mat-header-cell>
      <mat-cell *matCellDef="let row" class="ClsMatDescription" matTooltip={{row.tagDesc}} matTooltipPosition="above" matTooltipclass="tooltip">
        {{((row.tagDesc != null && row.tagDesc.length > 30 ) ? row.tagDesc.substring(0, 10) + "..." : row.tagDesc)}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef class="mat-column-action">Action</mat-header-cell>
      <mat-cell *matCellDef="let row" class="tbl_action">
        <button class="actionIcon  pointer" matTooltip="View" mat-icon-button (click)="updateDilog(row, 'View')">
          <mat-icon class="action-icon-view"></mat-icon>
        </button>
        <button *ngIf="globalService.hasTagAdminAccess() && globals.subscription == globals.subscription" class="actionIcon pointer" matTooltip="Edit" mat-icon-button (click)="updateDilog(row, 'update')">
          <mat-icon class="action-icon-edit"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
  </mat-table>
  <div *ngIf="noData" class="emptyRepoMsg">
    <span> There are no records to display.</span>
  </div> 
  <div *ngIf="startAct" class="emptyRepoMsg">
    <span>Select Location to continue with Tag.</span>
  </div> 
  <div *ngIf="isLoader" class="svg-loader"></div>
  <mat-paginator #tagsPaginator class="flex-wrap" [pageSize]="10" [pageSizeOptions]="[10, 50, 75, 100]" ngClass="{{firstTableClass}}"
  [hidden]="!tagList || !tagList.data.length">
  </mat-paginator>
</div>



